var _style, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg14X14BgWorkRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#448AFF;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 14,
    height: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.78,1.44c-1.01,0-1.82,0.82-1.82,1.83c0,1.02,0.81,1.84,1.83,1.84c1.01,0,1.83-0.82,1.83-1.84 C6.62,2.25,5.8,1.43,4.78,1.44z M5.59,2.82c0,0,0,0.01,0,0.01C5.56,2.88,5.5,2.92,5.46,2.97C5.19,3.25,4.92,3.54,4.65,3.82 C4.54,3.94,4.51,3.94,4.39,3.83C4.26,3.72,4.13,3.6,4,3.48C3.94,3.43,3.9,3.36,3.97,3.29C4.03,3.22,4.1,3.26,4.16,3.31 c0.12,0.11,0.23,0.21,0.36,0.32c0.29-0.3,0.57-0.59,0.84-0.88C5.38,2.72,5.4,2.68,5.43,2.67c0.01,0,0.02,0,0.03-0.01 C5.55,2.66,5.62,2.74,5.59,2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.85,6.31C2.86,6.18,2.94,6.1,3.09,6.1c0.3,0,0.6,0,0.9,0c0.27,0,0.53,0,0.8,0c0.55,0,1.1,0,1.65,0 c0.13,0,0.22,0.04,0.26,0.17c0.04,0.13-0.04,0.25-0.17,0.28C6.47,6.56,6.42,6.56,6.36,6.56c-1.06,0-2.12,0-3.17,0 c-0.04,0-0.08,0-0.12,0C2.93,6.54,2.84,6.44,2.85,6.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.12,6.32c0-0.13,0.1-0.22,0.25-0.22c0.61,0,1.21,0,1.82,0c0.6,0,1.19,0,1.79,0c0.08,0,0.18,0.05,0.23,0.1 c0.1,0.12,0.02,0.29-0.12,0.33c-0.05,0.01-0.11,0.02-0.16,0.02c-1.16,0-2.31,0-3.47,0c-0.03,0-0.06,0-0.09,0 C7.21,6.54,7.12,6.45,7.12,6.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.52,4.58C7.5,4.51,7.5,4.4,7.54,4.35C7.59,4.3,7.69,4.26,7.77,4.26c0.54-0.01,1.08,0,1.61,0 c0.53,0,1.06,0,1.59,0c0.18,0,0.28,0.08,0.28,0.22c0,0.14-0.11,0.23-0.29,0.23c-1.06,0-2.13,0-3.19,0 C7.66,4.71,7.55,4.69,7.52,4.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.24,7.94c1.27,0,2.54,0,3.81,0h3.82c0.03,0,0.05,0,0.08,0c0.19,0,0.29,0.09,0.29,0.23 c0,0.14-0.11,0.23-0.29,0.23c-2.59,0-5.19,0-7.78,0C2.96,8.4,2.83,8.26,2.9,8.1c0.03-0.07,0.11-0.12,0.18-0.15 C3.13,7.93,3.19,7.94,3.24,7.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.25,11.86c0,0.13-0.1,0.22-0.27,0.22c-0.3,0-0.61,0-0.91,0c-0.3,0-0.6,0-0.89,0 c-0.16,0-0.27-0.09-0.27-0.22c0-0.13,0.1-0.23,0.26-0.23c0.61,0,1.21,0,1.82,0C11.15,11.63,11.25,11.72,11.25,11.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.91,2.63C8.92,2.5,9.02,2.41,9.17,2.41c0.31,0,0.61,0,0.92,0c0.3,0,0.6,0,0.89,0c0.15,0,0.25,0.08,0.26,0.21 c0.01,0.13-0.1,0.24-0.25,0.24c-0.61,0-1.22,0-1.83,0C9.01,2.87,8.9,2.76,8.91,2.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.26,10.01c0,0.12-0.07,0.21-0.19,0.22c-0.05,0.01-0.1,0.01-0.15,0.01c-2.58,0-5.15,0-7.73,0 c-0.05,0-0.11,0-0.16-0.01c-0.12-0.02-0.18-0.1-0.18-0.22c0-0.12,0.06-0.2,0.18-0.22c0.05-0.01,0.11-0.01,0.16-0.01 c1.29,0,2.59,0,3.88,0c1.3,0,2.59,0,3.89,0C11.17,9.78,11.26,9.86,11.26,10.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.43,0.05H1.57c-0.22,0-0.41,0.18-0.41,0.41v13.08c0,0.09,0.03,0.17,0.08,0.24 c0.02,0.03,0.05,0.06,0.09,0.09c0.07,0.05,0.15,0.08,0.24,0.08h9.76c0.05,0,0.1,0,0.15-0.01c0.2-0.02,0.38-0.08,0.55-0.16 c0,0,0,0,0,0c0.37-0.19,0.64-0.54,0.75-0.95c0,0,0,0,0,0c0.03-0.12,0.05-0.25,0.05-0.37V0.46C12.83,0.23,12.65,0.05,12.43,0.05z  M12.37,0.66c0,3.91,0,7.81,0,11.72c0,0.69-0.39,1.08-1.08,1.1c-0.05,0-0.09,0-0.14,0H1.63V0.52h10.74V0.66z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg14X14BgWorkRequest);
export default __webpack_public_path__ + "static/media/14x14-bg-work-request.76cf47ae7751467977f4fd91fdd92652.svg";
export { ForwardRef as ReactComponent };